export default __webpack_public_path__ + "static/media/element_10.13115b9e.avif";